import { v4 as uuid } from "uuid";
import store from "@/redux/store";

import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import { connect } from "react-redux";
import { Overview } from "@/views/team/Overview";
import { open, close } from '@/reducers/Window'
import { TimeRegistrationWindowView } from "@/views/Window/Search/TimeRegistration";

import {quickSearch, setTaskKey} from "@/reducers/Dossier"
import { getTimeRegistrationForCustomer } from '@/reducers/Invoice'
  
class WindowSearchTimeRegistrationController extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, secret: null, prevType: props.type, customers:[], dossiers:[], searchTxt: '' };
    this.onSearchEventHandler = this.onSearchEventHandler.bind(this);
    this.getCustomersDossierHandler = this.getCustomersDossierHandler.bind(this);
    this.openDossierEventHandler = this.openDossierEventHandler.bind(this);
  }

    async componentDidMount() {
        
        //store.dispatch( getTimeRegistrationForCustomer(this.props.window.data) );
        
    }
componentDidUpdate() {
}

    onSearchEventHandler(event, searchTxt) {
        store.dispatch( quickSearch({name: searchTxt}) )   .then((event) => {
            if(event.type == 'QUICK_SEARCH/fulfilled' && event.payload?.data?.customers ) {
                this.setState({searchTxt: searchTxt, customers: event.payload.data.customers, dossiers: event.payload.data.dossiers, secret: uuid().slice(0, 8) }  );
            }
        });
    }
    
    getCustomersDossierHandler(customer) {
        store.dispatch( quickSearch({customer: customer.key, type: "dossiers"}) )   .then((event) => {
            if(event.type == 'QUICK_SEARCH/fulfilled' && event.payload?.data?.dossiers ) {
                this.setState({dossiers: event.payload.data.dossiers, secret: uuid().slice(0, 8) }  );
            }
        });
        
    }

    openDossierEventHandler(dossier) {
        
        //dossiers/view/QmIpR9llhe-082079887390137
        store.dispatch( close(this.props.window) );
            let link = "/dossiers/view/";
            if(dossier) {
                link += dossier.key;
            }
            this.props.navigateTo(link);
    }
    

  render() {
      const {customers, dossiers, secret, searchTxt} = this.state;
      const {registrations, window} = this.props;
      
      
      
    return (
        <TimeRegistrationWindowView key={uuid().slice(0, 8)} invoiceRow={this.props?.window?.data?.invoiceRow} customers={customers} dossiers={dossiers} window={window}/>
    );
    }
}

const WindowSearchTimeRegistrationControllerInit = (props) => {
    const navigateTo = useNavigate();
  return (
    <WindowSearchTimeRegistrationController
      {...props} navigateTo={navigateTo}
    />
  );
};

function mapStateToProps(state) {
    
    const {WindowReducer, InvoiceReducer} = state;
  return {
      key: WindowReducer.key,
      registrations: InvoiceReducer.customertimereg
  };
}
export default connect(mapStateToProps)(WindowSearchTimeRegistrationControllerInit);
